<div
  [id]="id?.toLowerCase()"
  [ngClass]="cardColor"
  class="flex flex-col p-4 rounded-lg w-full h-full box-border"
>
  <div
    *ngIf="observationsData != undefined"
    class="flex flex-col justify-between items-start gap-1 text-white"
  >
    <div class="instances text-4xl flex items-center justify-start w-full">
      {{ observationsData.observationCount }}
    </div>
    <div class="finding text-base flex items-center justify-start w-full">
      {{ observationsData.observationName }}
    </div>
  </div>
</div>
